import TaskVisualIcon from "@/components/training/TaskVisualIcon";
import { visualKindForTaskId } from "@/training/taskVisuals";

/**
 * Compact selectable Training task card — visual supports text; text remains primary.
 */
export default function TaskVisualCard({
  taskId,
  label,
  selected = false,
  onToggle,
  testId,
  visualKind,
}) {
  const kind = visualKind || visualKindForTaskId(taskId);
  return (
    <button
      type="button"
      className={`inline-flex items-center gap-2 min-h-11 px-3 py-2 rounded border text-sm text-left transition-colors ${
        selected ? "bg-primary text-primary-foreground border-primary" : "bg-background hover:bg-muted/50"
      }`}
      onClick={() => onToggle?.(taskId)}
      aria-pressed={selected}
      aria-label={label}
      data-testid={testId || (taskId ? `ql-task-${taskId}` : undefined)}
      data-task-id={taskId || undefined}
      data-visual-kind={kind}
    >
      <span className="shrink-0 inline-flex items-center justify-center w-8 h-8" aria-hidden="true">
        <TaskVisualIcon kind={kind} />
      </span>
      <span className="leading-snug">{label}</span>
    </button>
  );
}
